import React from "react";
import { useLocation } from "react-router-dom";

export default function Footer({
  page,
  navigate,
  logout,
  customer,
  isDiscountOn,
}) {
  const location = useLocation();

  return (
    <div
      className={`${
        page === "dashboard"
          ? "bg-light-beige text-purple-950"
          : "bg-purple-950 text-white"
      } ${
        isDiscountOn ? "mb-20 sm:mb-0" : ""
      } shrink-0 w-full text-sm flex flex-row items-start justify-start relative"`}
    >
      <div className="flex flex-wrap items-center max-w-5xl space-y-4 sm:space-y-0 sm:space-x-4 xl:px-0 px-6 h-full mx-auto justify-start sm:justify-between  w-full z-10 py-4 sm:py-8">
        <div className="flex w-full sm:w-1/3 items-center justify-start space-x-1.5">
          <p className="">© 2024 StashCampus, Inc.</p>
          <div
            className={`w-0.5 h-0.5 ${
              page === "dashboard" ? "bg-purple-950" : "bg-white"
            }`}
          ></div>
          <a
            href="/terms"
            target={"_blank"}
            className=" hover:opacity-50 transition-all"
          >
            Terms
          </a>
          {/* <div className="w-0.5 h-0.5 bg-white"></div>
          <p className="">Privacy</p> */}
        </div>
        <div className="flex flex-1 items-center justify-between sm:justify-center">
          <button
            onClick={(e) => {
              e.preventDefault();

              // pageTopRef.current.scrollIntoView({
              //   behavior: "smooth",
              //   // block: "start",
              //   // inline: "nearest",
              // });
              navigate("/");
            }}
            className="transition-all hover:opacity-50"
          >
            <svg
              className={`h-8 fill-current `}
              viewBox="0 0 71 77"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M35.5 0C23.1137 0 9.12673 5.36113 0 12.8333C0 40.3544 16.3655 64.4875 35.5 77C54.6345 64.4875 71 40.3544 71 12.8333C61.8733 5.36113 47.9153 0 35.5 0Z" />
              <path
                d="M35.5 9.67892C26.5503 9.67892 16.444 13.36 9.84949 18.4906C9.84949 37.3873 21.6744 53.9576 35.5 62.549C49.3257 53.9576 61.1505 37.3873 61.1505 18.4906C54.556 13.36 44.4707 9.67892 35.5 9.67892Z"
                fill={page === "dashboard" ? "white" : "rgb(59, 7, 100)"}
              />
              <path d="M27.9557 49.5809C31.9793 50.5784 40.0265 50.5784 41.0325 47.087L7.20621 25.1409H6.83189C5.39752 36.4862 6.43686 30.4299 13.3701 42.0993C13.3701 42.0993 23.9321 48.5833 27.9557 49.5809Z" />
              <path d="M36.5059 20.1532C44.0501 20.1532 62.6595 27.6348 62.6595 27.6348L64.1684 33.6201L59.1387 38.1091L26.9498 23.6446C26.9498 23.6446 28.9617 20.1532 36.5059 20.1532Z" />
            </svg>
            {/* <div className="h-8 w-24 bg-white rounded-lg"></div> */}
          </button>
        </div>
        <div className="flex items-center justify-end space-x-4  sm:w-1/3">
          {/* <a
            href="https://twitter.com/storeu"
            target={"_blank"}
            rel={"noreferrer"}
            className="flex  aspect-square rounded-full items-center justify-start space-x-2 hover:opacity-50 transition-opacity"
          >
            <svg
              className="h-4 w-5 fill-current"
              viewBox="0 0 20 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M20 2.05101C19.2675 2.39681 18.4894 2.62491 17.6919 2.7276C18.5572 2.18346 19.1988 1.32237 19.4922 0.311214C18.6885 0.807755 17.8107 1.15902 16.8956 1.35026C16.3319 0.724466 15.6019 0.289984 14.7999 0.102933C13.998 -0.0841177 13.1609 -0.0151455 12.3967 0.300941C11.6326 0.617028 10.9765 1.16571 10.5133 1.87611C10.05 2.58652 9.8009 3.42601 9.79804 4.28616C9.79706 4.61544 9.83191 4.94377 9.9019 5.26479C8.26684 5.19547 6.66415 4.76578 5.19852 4.00381C3.73289 3.24183 2.43731 2.16471 1.39642 0.842818C1.03932 1.47638 0.848233 2.19737 0.84247 2.93299C0.835589 3.64804 0.998632 4.35366 1.31693 4.98636C1.63522 5.61906 2.09878 6.15899 2.6659 6.55756C2.01564 6.53297 1.37967 6.35101 0.807847 6.02595C0.805736 7.01723 1.13259 7.97849 1.73253 8.7454C2.33246 9.51231 3.16823 10.0372 4.09694 10.2305C3.74466 10.3383 3.37913 10.3912 3.01212 10.3875C2.75216 10.3898 2.49278 10.3614 2.23889 10.3029C2.50088 11.1563 3.011 11.9027 3.69795 12.4377C4.3849 12.9728 5.21435 13.2697 6.0704 13.2872C4.62211 14.4862 2.82734 15.1338 0.980958 15.1236C0.653018 15.1278 0.325207 15.1077 0 15.0632C1.76194 16.2485 3.79638 16.9149 5.88943 16.9924C7.98247 17.0698 10.0568 16.5555 11.8943 15.5034C13.7318 14.4513 15.2645 12.9004 16.3315 11.0137C17.3984 9.12691 17.96 6.97409 17.9573 4.78152C17.9573 4.60029 17.9573 4.40698 17.9573 4.22575C18.7552 3.63244 19.4468 2.89621 20 2.05101Z" />
            </svg>
          </a> */}
          <a
            href="mailto:stashcampus.com"
            target={"_blank"}
            rel={"noreferrer"}
            className="flex  aspect-square rounded-full items-center justify-start space-x-2 hover:opacity-50 transition-opacity"
          >
            <svg
              className="h-7 fill-current"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 8L12 13L20 8V18H4V8ZM4 6L12 11L20 6H4Z"
              />
            </svg>
          </a>
          <a
            href="https://instagram.com/stashcampus"
            target={"_blank"}
            rel={"noreferrer"}
            className="flex  aspect-square rounded-full items-center justify-start space-x-2 hover:opacity-50 transition-opacity"
          >
            <svg
              className="h-5 w-5 fill-current"
              viewBox="0 0 70 70"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M35 6.30547C44.3461 6.30547 45.4535 6.34102 49.1422 6.51055C52.5547 6.66641 54.4086 7.23516 55.6418 7.71641C57.2742 8.35078 58.4418 9.11094 59.6668 10.3359C60.8918 11.5609 61.6492 12.7258 62.2836 14.3609C62.7621 15.5941 63.3336 17.448 63.4895 20.8605C63.659 24.552 63.6945 25.6594 63.6945 35.0027C63.6945 44.3461 63.659 45.4562 63.4895 49.1449C63.3336 52.5574 62.7648 54.4113 62.2836 55.6445C61.6492 57.277 60.8891 58.4445 59.6668 59.6695C58.4418 60.8945 57.277 61.652 55.6418 62.2863C54.4086 62.7648 52.5547 63.3363 49.1422 63.4922C45.4508 63.6617 44.3461 63.6973 35 63.6973C25.6539 63.6973 24.5465 63.6617 20.8578 63.4922C17.4453 63.3363 15.5914 62.7676 14.3582 62.2863C12.7258 61.652 11.5582 60.8918 10.3332 59.6695C9.1082 58.4445 8.35078 57.2797 7.71641 55.6445C7.23789 54.4113 6.66641 52.5574 6.51055 49.1449C6.34102 45.4535 6.30547 44.3461 6.30547 35.0027C6.30547 25.6594 6.34102 24.5492 6.51055 20.8605C6.66641 17.448 7.23516 15.5941 7.71641 14.3609C8.35078 12.7285 9.11094 11.5609 10.3332 10.3359C11.5582 9.11094 12.723 8.35352 14.3582 7.71641C15.5914 7.23789 17.4453 6.66641 20.8578 6.51055C24.5492 6.34102 25.6566 6.30547 35 6.30547ZM35 0C25.4953 0 24.3031 0.0410156 20.5707 0.210547C16.8465 0.380078 14.3008 0.973437 12.075 1.8375C9.77266 2.73164 7.82031 3.9293 5.87617 5.87344C3.9293 7.82031 2.73438 9.76992 1.84023 12.0723C0.973437 14.3008 0.380078 16.8438 0.210547 20.5707C0.0410156 24.3031 0 25.4953 0 35C0 44.5047 0.0410156 45.6969 0.210547 49.4293C0.380078 53.1535 0.973437 55.6992 1.8375 57.925C2.73164 60.2273 3.9293 62.1797 5.87344 64.1238C7.82031 66.0707 9.76992 67.2656 12.0723 68.1598C14.298 69.0238 16.8438 69.6172 20.568 69.7867C24.3004 69.9563 25.4926 69.9973 34.9973 69.9973C44.502 69.9973 45.6941 69.9563 49.4266 69.7867C53.1508 69.6172 55.6965 69.0238 57.9223 68.1598C60.2246 67.2656 62.177 66.068 64.1211 64.1238C66.068 62.177 67.2629 60.2273 68.157 57.925C69.0211 55.6992 69.6145 53.1535 69.784 49.4293C69.9535 45.6969 69.9945 44.5047 69.9945 35C69.9945 25.4953 69.9535 24.3031 69.784 20.5707C69.6145 16.8465 69.0211 14.3008 68.157 12.075C67.2629 9.77266 66.0652 7.82031 64.1211 5.87617C62.1742 3.9293 60.2246 2.73438 57.9223 1.84023C55.6965 0.976172 53.1508 0.382812 49.4266 0.213281C45.6941 0.04375 44.502 0.00273437 34.9973 0.00273437L35 0ZM35 17.027C25.0742 17.027 17.027 25.0742 17.027 35C17.027 44.9258 25.0742 52.973 35 52.973C44.9258 52.973 52.973 44.9258 52.973 35C52.973 25.0742 44.9258 17.027 35 17.027ZM35 46.6676C28.5578 46.6676 23.3324 41.4449 23.3324 35C23.3324 28.5551 28.5551 23.3324 35 23.3324C41.4449 23.3324 46.6676 28.5551 46.6676 35C46.6676 41.4449 41.4449 46.6676 35 46.6676ZM57.884 16.316C57.884 18.6348 56.0027 20.516 53.684 20.516C51.3652 20.516 49.484 18.6348 49.484 16.316C49.484 13.9973 51.3652 12.116 53.684 12.116C56.0027 12.116 57.884 13.9973 57.884 16.316Z" />
            </svg>
          </a>
          {/* <a
            href="https://twitter.com/stashcampus"
            target={"_blank"}
            rel={"noreferrer"}
            className="flex  aspect-square rounded-full items-center justify-start space-x-2 hover:opacity-50 transition-opacity"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              className="h-5 w-5 fill-current"
            >
              <path d="M14.258 10.152L23.176 0h-2.113l-7.747 8.813L7.133 0H0l9.352 13.328L0 23.973h2.113l8.176-9.309 6.531 9.309h7.133zm-2.895 3.293l-.949-1.328L2.875 1.56h3.246l6.086 8.523.945 1.328 7.91 11.078h-3.246zm0 0" />
            </svg>
          </a> */}

          {/* <a
            href="https://www.tiktok.com/storeu"
            target={"_blank"}
            rel={"noreferrer"}
            className="flex   aspect-square rounded-full  items-center justify-start space-x-2 hover:opacity-50 transition-opacity"
          >
            <svg
              className="h-[1.1rem] fill-current"
              viewBox="0 0 20 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7988 8.20303C16.3181 9.28271 18.1359 9.86231 19.9997 9.86129V6.09251C19.6325 6.09225 19.2663 6.05436 18.9068 5.97945V8.91909C17.0429 8.92012 15.2251 8.34051 13.7059 7.26083V14.8738C13.7059 16.7029 12.9792 18.4572 11.6858 19.7506C10.3924 21.044 8.63816 21.7706 6.809 21.7706C5.43927 21.7767 4.09954 21.3695 2.96484 20.6023C3.92291 21.5845 5.15216 22.2586 6.49541 22.5384C7.83865 22.8183 9.23483 22.6911 10.5054 22.1731C11.776 21.6552 12.8632 20.77 13.628 19.6309C14.3928 18.4917 14.8004 17.1503 14.7988 15.7783V8.20303ZM16.143 4.43425C15.3791 3.59216 14.9076 2.52585 14.7988 1.39411V0.891602H13.7687C13.8934 1.61241 14.1695 2.29859 14.5787 2.9049C14.988 3.51122 15.5211 4.02389 16.143 4.40913V4.43425ZM5.37686 17.7129C4.94981 17.1692 4.7235 16.4947 4.73617 15.8034C4.73617 14.9671 5.06838 14.1651 5.65972 13.5737C6.25106 12.9824 7.05309 12.6502 7.88938 12.6502C8.21357 12.65 8.53576 12.7009 8.84414 12.8009V9.03216C8.48025 9.00717 8.11508 9.00717 7.75119 9.03216V12.0095C7.44282 11.9095 7.12062 11.8586 6.79643 11.8587C6.08758 11.8594 5.39964 12.099 4.84363 12.5387C4.28763 12.9784 3.89599 13.5926 3.73194 14.2822C3.56788 14.9718 3.64098 15.6966 3.93942 16.3395C4.23787 16.9825 4.74426 17.5061 5.37686 17.826V17.7129Z"
                fill="#ED2153"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.7054 7.29852C15.2246 8.3782 17.0425 8.9578 18.9063 8.95678V6.01714C17.8422 5.79151 16.8756 5.23792 16.1425 4.43425C15.5178 4.04631 14.9829 3.5297 14.5735 2.91884C14.1641 2.30798 13.8896 1.61688 13.7682 0.891602H11.0421V15.816C11.0388 16.6501 10.7051 17.4489 10.1141 18.0375C9.52314 18.6261 8.72301 18.9566 7.88889 18.9566C7.40098 18.9586 6.91942 18.8459 6.48302 18.6277C6.04661 18.4095 5.66755 18.0919 5.37638 17.7003C4.74377 17.3805 4.23739 16.8569 3.93894 16.2139C3.6405 15.5709 3.5674 14.8462 3.73146 14.1566C3.89551 13.4669 4.28714 12.8527 4.84315 12.413C5.39915 11.9733 6.0871 11.7338 6.79595 11.7331C7.1202 11.7321 7.44253 11.783 7.75071 11.8839V8.91909C6.4051 8.94666 5.09696 9.36734 3.98751 10.1293C2.87806 10.8912 2.0158 11.9611 1.50698 13.2071C0.99816 14.4531 0.865028 15.8208 1.12399 17.1415C1.38295 18.4623 2.02269 19.6784 2.96436 20.64C4.09906 21.4072 5.43878 21.8144 6.80851 21.8083C8.63767 21.8083 10.3919 21.0817 11.6853 19.7883C12.9787 18.4949 13.7054 16.7406 13.7054 14.9114V7.29852Z"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.9069 6.01748V5.22604C17.93 5.22379 16.9731 4.94975 16.1431 4.43459C16.8788 5.23497 17.8443 5.78791 18.9069 6.01748ZM13.7688 0.891944C13.7688 0.741193 13.7688 0.603004 13.706 0.464816V0H9.93719V14.9118C9.93478 15.449 9.79518 15.9766 9.53162 16.4447C9.26807 16.9128 8.8893 17.3058 8.43124 17.5864C7.97318 17.8671 7.45102 18.026 6.9143 18.0482C6.37757 18.0704 5.84407 17.9551 5.36441 17.7133C5.65558 18.1048 6.03464 18.4224 6.47104 18.6406C6.90745 18.8588 7.38901 18.9715 7.87692 18.9695C8.71103 18.9695 9.51117 18.639 10.1021 18.0504C10.6931 17.4618 11.0268 16.663 11.0301 15.8289V0.891944H13.7688ZM7.7513 8.89431V8.05262C7.4394 8.00672 7.12434 7.98572 6.8091 7.98981C5.34747 8.00841 3.92954 8.49092 2.75994 9.36772C1.59035 10.2445 0.729577 11.4703 0.301857 12.868C-0.125863 14.2658 -0.098414 15.7633 0.380244 17.1445C0.858901 18.5257 1.76401 19.719 2.96495 20.5524C2.02328 19.5908 1.38354 18.3747 1.12458 17.0539C0.865618 15.7332 0.99875 14.3655 1.50757 13.1195C2.01639 11.8735 2.87866 10.8036 3.9881 10.0417C5.09755 9.27975 6.40569 8.85907 7.7513 8.8315V8.89431Z"
                fill="#93C5FD"
              />
            </svg>
          </a> */}
          <button
            onClick={(e) => {
              if (location.pathname === "/login") {
                console.log(1);
                navigate("/signup");
              } else {
                console.log(2);

                if (customer) {
                  logout();
                  navigate("/login");
                } else {
                  navigate("/login");
                }
              }
            }}
            className={` group hidden flex-shrink-0 sm:flex hover:bg-gray-100/10 ${
              page === "dashboard" ? "border-purple-950" : "border-white"
            } border transition-all items-center justify-center space-x-2 rounded-lg backdrop-blur-sm pl-4 pr-3 py-1`}
          >
            <p className="font-bold">
              {location.pathname === "/login"
                ? "Sign up"
                : customer
                ? "Logout"
                : "Sign in"}
            </p>
            <svg
              className="h-2.5 fill-current"
              viewBox="0 0 11 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className=" -translate-x-1 group-hover:translate-x-0 transition-all"
                d="M5.33198 0L4 1.175L8.32659 5L4 8.825L5.33198 10L11 5L5.33198 0Z"
              />
              <rect
                className="opacity-0 group-hover:opacity-100 transition-all"
                y="4"
                width="9"
                height="2"
              />
            </svg>
          </button>
          <button
            onClick={(e) => {
              if (location.pathname === "/login") {
                console.log(1);
                navigate("/signup");
              } else {
                console.log(2);

                if (customer) {
                  logout();
                  navigate("/login");
                } else {
                  navigate("/login");
                }
              }
            }}
            className={` group hover:bg-gray-100/10  ${
              page === "dashboard" ? "border-purple-950" : "border-white"
            } flex sm:hidden border transition-all items-center justify-center space-x-2 rounded-lg backdrop-blur-sm pl-4 pr-3 py-1`}
          >
            <p className="font-bold">
              {location.pathname === "/login"
                ? "Sign up"
                : customer
                ? "Logout"
                : "Sign in"}
            </p>

            <svg
              className="h-2.5 fill-current"
              viewBox="0 0 11 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className=" -translate-x-1 group-hover:translate-x-0 transition-all"
                d="M5.33198 0L4 1.175L8.32659 5L4 8.825L5.33198 10L11 5L5.33198 0Z"
              />
              <rect
                className="opacity-0 group-hover:opacity-100 transition-all"
                y="4"
                width="9"
                height="2"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
